import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { ResultListTileItemComponent } from '../result-list-tile-item/result-list-tile-item.component';
import { ResultListBase } from '../result-list.base';

@UntilDestroy()
@Component({
  selector: 'cat-result-list-tile',
  templateUrl: './result-list-tile.component.html',
  styleUrls: ['./result-list-tile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, ResultListTileItemComponent]
})
export class ResultListTileComponent extends ResultListBase implements OnChanges {
  @Input() singleColumn = false;

  ngOnChanges(): void {
    this.initDropboxImages();
  }

  protected readonly indexedDB = indexedDB;
}
